var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['man-hour-modal-header__option', { active: _vm.active }],on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.active)?_c('div',{staticClass:"active-line"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }